import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PipelineVariablesEditorOptions, VariableEditorPermissionLevel } from '@selfai-platform/pipeline-common';
import { DialogService } from '@selfai-platform/shell';
import { Observable } from 'rxjs';
import { LocalVariablesPermissionService } from '../../services/';
import { PipelineVariablesTreeComponent } from '../pipeline-variables-tree';

@Component({
  selector: 'selfai-platform-pipeline-variables-editor',
  standalone: true,
  templateUrl: './pipeline-variables-editor.component.html',
  styleUrls: ['./pipeline-variables-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PipelineVariablesTreeComponent],
  providers: [LocalVariablesPermissionService],
})
export class PipelineVariablesEditorComponent {
  protected userPermissions$: Observable<VariableEditorPermissionLevel[]>;
  protected readonly data = this.dialogService.data;

  constructor(
    private readonly dialogService: DialogService<never, PipelineVariablesEditorOptions>,
    private readonly variablesPermissionService: LocalVariablesPermissionService,
  ) {
    this.userPermissions$ = this.variablesPermissionService.getUserPermissions(this.data.workflowId);
  }
}
